export default {
    data() {
        return {
            windowWidth: null
        }
    },

    created() {
        this.setWindowWidth();

        const that = this;

        window.addEventListener('resize', function () {
            that.setWindowWidth();
        });
    },

    computed: {
        showMobile() {
            return this.windowWidth < 600;
        },
    },

    methods: {
        setWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
        },
    }
}
